export default __webpack_public_path__ + "static/Montserrat-ExtraLight-62a749ca2820713ebbf8785ed33a8893.ttf";